const eventTracking = (category, action, label) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'event',
    eventProps: {
      category,
      action,
      label,
    },
  });
};

export default eventTracking;
